import _ from "lodash"

export const User = {
	UnauthenticatedUser: {
		brand: { reference: "Clearview", name: "Clearview" },
		name: "Unauthenticated",
		username: "unauthenticated",
		initials: "...",
		teams: [],
		favourites: [],
		groups: [],
		id: 0,
		isInHouse: false,
	},
	UnassignedInHouseUser: {
		brand: { reference: "Clearview", name: "Clearview" },
		name: "Unassigned",
		username: undefined,
		initials: "?",
		teams: [],
		favourites: [],
		groups: [],
		id: 0,
		isInHouse: true,
		title: "Unassigned",
		bgColor: "secondary",
	},
	AllInHouseUsers: {
		brand: { reference: "Clearview", name: "Clearview" },
		name: "All Users",
		username: undefined,
		initials: "All",
		teams: [],
		favourites: [],
		groups: [],
		id: 0,
		isInHouse: true,
		title: "All",
		bgColor: "warning",
	},

	IsAdmin(user) {
		if (!user || !user.teams) return false
		return !!_.find(user.teams, it => it.type === "Users" && (it.role === "Admin" || it.role === "System"))
	},
}
